import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Container, FormSelect, Icon, Loader, Menu, MenuItem, Segment, SegmentGroup, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';

import { costoDespachoFecha, isSuccess } from "../../api";
import moment from '../../utils/Moment'
import { AppHeader } from '../../components';
import Screen from '../Screen';
import { ANIOS, clp } from '../../utils';


const OPCIONES_MES = [
  { key: '01', text: 'Enero', value: 0 },
  { key: '02', text: 'Febrero', value: 1 },
  { key: '03', text: 'Marzo', value: 2 },
  { key: '04', text: 'Abril', value: 3 },
  { key: '05', text: 'Mayo', value: 4 },
  { key: '06', text: 'Junio', value: 5 },
  { key: '07', text: 'Julio', value: 6 },
  { key: '08', text: 'Agosto', value: 7 },
  { key: '09', text: 'Septiembre', value: 8 },
  { key: '10', text: 'Octubre', value: 9 },
  { key: '11', text: 'Noviembre', value: 10 },
  { key: '12', text: 'Diciembre', value: 11 },
]

let opciones_anios = []

for (let anio of ANIOS) {
  opciones_anios.push({
    key: anio, text: anio.toString(), value: anio
  })
}

class Repartos extends Screen {
  state = {
    loading: true,
    datos: [],
    anio: moment().year(),
    mes: moment().month()
  }

  componentDidMount() {
    this.fetch(this.state.mes)
  }

  fetch = async () => {
    try {
      this.startLoading()
      this.setState({ datos: [] })
      const desde = moment().year(this.state.anio).month(this.state.mes).startOf('month').format('YYYY-MM-DDT00:00:00')
      const hasta = moment().year(this.state.anio).month(this.state.mes).endOf('month').format('YYYY-MM-DDT23:59:59')
      //console.log(this.state.mes, this.state.anio, desde, hasta)
      const data = await costoDespachoFecha(desde, hasta)
      if (isSuccess(data)) {
        this.setState({ datos: data.data })
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.stopLoading()
    }
  }

  onMesChange = (e, { value }) => {
    this.setState({ mes: value })
  }

  onAnioChange = (e, { value }) => {
    this.setState({ anio: value })
  }

  volver = () => this.props.history.goBack()

  render() {
    const { datos } = this.state
    const total = datos.reduce((t, item) => (t + item.despacho), 0)

    return (
      <div>
        <AppHeader>
          <Menu.Item onClick={this.volver}>
            <Icon name="chevron left" size="big" />
            Volver
          </Menu.Item>
          <Menu.Item>
            <Icon name="motorcycle" />
            Repartos del mes
          </Menu.Item>
        </AppHeader>
        <Container>
          <SegmentGroup horizontal>
            <Segment>
              <FormSelect fluid options={opciones_anios} value={this.state.anio} onChange={this.onAnioChange} disabled={this.state.loading} />
            </Segment>
            <Segment>
              <FormSelect fluid options={OPCIONES_MES} value={this.state.mes} onChange={this.onMesChange} disabled={this.state.loading} />
            </Segment>
            <Segment><Button primary fluid onClick={this.fetch} loading={this.state.loading}>Buscar</Button></Segment>
          </SegmentGroup>
          <Segment><strong>Total de repartos del Mes: {clp(total)}</strong></Segment>
          <Table celled>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>Dia</TableHeaderCell>
                <TableHeaderCell>Nombre</TableHeaderCell>
                <TableHeaderCell>Monto Despacho</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
            {datos.map((item, index) => (
              <TableRow key={index} negative={item.nombre === null}>
                <TableCell>{item.dia}</TableCell>
                <TableCell>{item.nombre || "REPARTO SIN ASIGNACION"}</TableCell>
                <TableCell>{clp(item.despacho)}</TableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
          <Loader active={this.state.loading} inline="centered" size="large" />
        </Container>
      </div>
    )
  }
}

/*
function sortDates(a, b) {
  return moment(a).isBefore(b) ? -1  : 1
}
*/

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch)

/*const mapDispatchToProps = (dispatch) => ({
  fijarJornadas: (offset) => dispatch(fijarJornadas(offset)),
  fijarJornadaActiva: () => dispatch(fijarJornadaActiva()),
  limpiar_jornadas: () => dispatch(limpiar_jornadas())
})*/

export default connect(mapStateToProps, mapDispatchToProps)(Repartos)